import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '剧集大全' },
    { to: '/category/korean', label: '韩剧' },
    { to: '/category/american', label: '美剧' },
    { to: '/category/chinese', label: '国产剧' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className="ri-movie-2-line text-2xl text-primary-500"></i>
          </div>
          <span className="text-xl font-heading font-bold text-foreground-950 tracking-wide">
            星空影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                isActive(link.to)
                  ? 'bg-primary-500/20 text-primary-500'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-foreground-700"></i>
          </button>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${
                  isActive(link.to)
                    ? 'bg-primary-500/20 text-primary-500'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}